import React from "react"

import {FieldGoalListViewProps} from "../../../render/goal-list/goal-list-view"
import FieldViewSmall from "../../../render/view-small"

export default function FieldProto_GoalListView(props:FieldGoalListViewProps) {
    return <FieldViewSmall {...props} />
}
